export const SUPPORTED_LOCALES = ['en', 'ru', 'de', 'fr'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: SupportedLocale = 'en'
export const FALLBACK_LOCALE: SupportedLocale = 'ru'

export const isSupportedLocale = (value: unknown): value is SupportedLocale =>
  typeof value === 'string' && SUPPORTED_LOCALES.includes(value as SupportedLocale)

export const detectLocale = (): SupportedLocale => {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE

  const browserLocale = navigator.language.toLowerCase()
  const exactLocale = SUPPORTED_LOCALES.find((locale) => locale === browserLocale)
  if (exactLocale) return exactLocale

  const shortLocale = browserLocale.split('-')[0]
  return isSupportedLocale(shortLocale) ? shortLocale : DEFAULT_LOCALE
}
